<template>
  <div style="padding-top: 50px">
    <div style="font-weight: bold; font-size: 18px; margin-bottom: 4px">
      幸福驾道出行平台价格公示
    </div>
    <div style="display: flex">
      <div
        v-for="(item, index) in priceList"
        :key="index"
        style="
          border: 1px solid;
          padding: 15px;
          margin-right: 16px;
          font-size: 14px;
        "
      >
        <div class="form_alone">
          {{ item.title }}
        </div>
        <div class="form_alone">分段起步费用</div>
        <div>
          <div class="form_item">
            <div class="tab_label">
              普通时段（{{ item.startDistance }}公里，{{
                item.startPackageTime
              }}分钟）
            </div>
            <div class="tab_value">{{ item.startPrice }}元</div>
          </div>
          <div
            v-for="(ite, key, ind) in item.startPriceInterval"
            :key="ind"
            class="form_item"
          >
            <div class="tab_label">
              {{ key }}（{{ item.startDistance }}公里，{{
                index == 2 ? 9 : item.startPackageTime
              }}分钟）
            </div>
            <div class="tab_value">{{ ite }}元</div>
          </div>
        </div>
        <div class="form_alone">分段里程费</div>
        <div>
          <div class="form_item">
            <div class="tab_label">普通时段</div>
            <div class="tab_value">{{ item.normalUnitPrice }}元/公里</div>
          </div>
          <div
            v-for="(ite, key, ind) in item.distanceInterval"
            :key="ind"
            class="form_item"
          >
            <div class="tab_label">{{ key }}</div>
            <div class="tab_value">{{ ite }}元/公里</div>
          </div>
        </div>
        <div class="form_alone">分段时长费</div>
        <div>
          <div class="form_item">
            <div class="tab_label">普通时段</div>
            <div class="tab_value">{{ item.timeUnitPrice }}元/分钟</div>
          </div>
          <div
            v-for="(ite, key, ind) in item.timeInterval"
            :key="ind"
            class="form_item"
          >
            <div class="tab_label">{{ key }}</div>
            <div class="tab_value">{{ ite }}元/分钟</div>
          </div>
        </div>
        <div class="form_alone">远途费</div>
        <div>
          <div
            v-for="(ite, key, ind) in item.distanceSerialInterval"
            :key="ind"
            class="form_item"
          >
            <div class="tab_label">
              <span>超过{{ key }}公里</span>
              <span v-if="Object.keys(item.distanceSerialInterval)[ind + 1]"
                >~{{
                  Object.keys(item.distanceSerialInterval)[ind + 1]
                }}公里</span
              >
              <span>，额外收取</span>
            </div>
            <div class="tab_value">{{ ite }}元/公里</div>
          </div>
        </div>
        <div>
          <div class="form_alone">临时加价</div>
          <div class="form_alone">
            当处于高峰时段，周围司机较少，或司机距离乘客较远时，为鼓励司机更快接单，平台会对订单进行适当加价。加价系数最高为1.5倍，加价金额上限为39.0元
          </div>
        </div>
      </div>
    </div>
    <div style="margin: 4px 0 8px">
      于2025年12月4号公示 适用区域:浙江省杭州市全区域
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      priceList: [
        {
          title: "（工作日）实时单计价规则",
          startPrice: "10.40",
          startDistance: "3",
          startPackageTime: "8",
          normalUnitPrice: "1.28", //普通时段里程费
          timeUnitPrice: "0.16", //普通时段时间费
          startPriceInterval: {
            "00:00-06:00": "10.81",
            "07:30-09:30": "11.30",
            "17:00-19:00": "10.77",
            "23:00-00:00": "10.81",
          },
          distanceInterval: {
            "00:00-06:00": "1.73",
            "07:30-09:30": "1.53",
            "17:00-19:00": "1.31",
            "23:00-00:00": "1.73",
          },
          timeInterval: {
            "00:00-06:00": "0.29",
            "07:30-09:30": "0.29",
            "17:00-19:00": "0.25",
            "19:00-23:00": "0.23",
            "23:00-00:00": "0.29",
          },
          distanceSerialInterval: {
            17: "0.15",
            25: "0.46",
            40: "0.54",
          },
        },
        {
          title: "（节假日）实时单计价规则",
          startPrice: "10.51",
          startDistance: "3",
          startPackageTime: "8",
          normalUnitPrice: "1.24", //普通时段里程费
          timeUnitPrice: "0.15", //普通时段时间费
          startPriceInterval: {
            "00:00-06:00": "10.54",
            "11:00-14:00": "10.51",
            "16:00-19:00": "10.76",
            "23:00-00:00": "10.51",
          },
          distanceInterval: {
            "00:00-06:00": "1.69",
            "11:00-14:00": "1.28",
            "16:00-19:00": "1.28",
            "23:00-00:00": "1.69",
          },
          timeInterval: {
            "00:00-06:00": "0.29",
            "11:00-14:00": "0.21",
            "16:00-19:00": "0.25",
            "19:00-23:00": "0.25",
            "23:00-00:00": "0.29",
          },
          distanceSerialInterval: {
            17: "0.13",
            25: "0.44",
            40: "0.51",
          },
        },
        // {
        //     title: "（工作日）预约单计价规则",
        //     startPrice: "8.42",
        //     startDistance: "3.5",
        //     startPackageTime: "11",
        //     normalUnitPrice: "0.77", //普通时段里程费
        //     timeUnitPrice: "0.1", //普通时段时间费
        //     startPriceInterval: {
        //         "00:00-05:00": "9.04",
        //         "05:00-07:00": "8.59",
        //         "07:00-09:00": "8.78",
        //         "17:00-19:00": "8.67",
        //         "23:00-00:00": "8.85",
        //     },
        //     distanceInterval: {
        //         "00:00-05:00": "1.68",
        //         "05:00-07:00": "0.85",
        //         "07:00-09:00": "1.18",
        //         "17:00-19:00": "1.15",
        //         "19:00-23:00": "0.82",
        //         "23:00-00:00": "1.62",
        //     },
        //     timeInterval: {
        //         "00:00-05:00": "0.18",
        //         "05:00-07:00": "0.11",
        //         "07:00-09:00": "0.17",
        //         "17:00-19:00": "0.16",
        //         "19:00-23:00": "0.11",
        //         "23:00-00:00": "0.18",
        //     },
        //     distanceSerialInterval: {
        //         8: "0.26",
        //         20: "0.77",
        //     },
        // },
        // {
        //     title: "（节假日）预约单计价规则",
        //     startPrice: "8.66",
        //     startDistance: "3.5",
        //     startPackageTime: "11",
        //     normalUnitPrice: "0.88", //普通时段里程费
        //     timeUnitPrice: "0.13", //普通时段时间费
        //     startPriceInterval: {
        //         "00:00-05:00": "9.31",
        //         "05:00-07:00": "8.75",
        //         "09:00-17:00": "8.75",
        //         "17:00-19:00": "9.13",
        //         "19:00-23:00": "8.75",
        //         "23:00-00:00": "9.41",
        //     },
        //     distanceInterval: {
        //         "00:00-05:00": "1.91",
        //         "05:00-07:00": "0.96",
        //         "07:00-09:00": "1.25",
        //         "17:00-19:00": "1.31",
        //         "23:00-00:00": "1.74",
        //     },
        //     timeInterval: {
        //         "00:00-05:00": "0.21",
        //         "05:00-07:00": "0.15",
        //         "07:00-09:00": "0.18",
        //         "17:00-19:00": "0.19",
        //         "23:00-00:00": "0.2",
        //     },
        //     distanceSerialInterval: {
        //         8: "0.29",
        //         20: "0.85",
        //     },
        // },
      ],
    };
  },
};
</script>
<style scoped>
.form_alone {
  padding: 5px 0;
}
.form_item {
  display: flex;
  justify-content: space-between;
  padding: 3px 0;
}
.tab_label {
  width: 72%;
  text-align: left;
}
.tab_value {
  flex: 1;
  text-align: right;
}
</style>
